import { render, staticRenderFns } from "./menuBottom.vue?vue&type=template&id=a7cf6fdc&scoped=true"
import script from "./menuBottom.vue?vue&type=script&lang=js"
export * from "./menuBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7cf6fdc",
  null
  
)

export default component.exports